import React, { useState } from 'react';
import PropTypes from 'prop-types';
import 'lazysizes';
import 'lazysizes/plugins/video-embed/ls.video-embed';
import { Button, Modal } from 'react-bootstrap';
import PicturePlayer from './PicturePlayer.jsx';

const PictureModalPlayer = (props) => {
  let [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return <>
    <Button size="sm" variant='outline-dark' className='white-space-nowrap mb-2 mb-md-0' title={ gettext('Показать видео крупно') }
            onClick={ handleShow }>
      <i className='icon icon-youtube-play'></i> { gettext('Показать видео') }
    </Button>

    <Modal show={ show } onHide={ handleClose } size='lg'>
      <Modal.Header closeButton>
        <Modal.Title>
          { props.title }<br/><small>{ props.author }</small>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <PicturePlayer code={ props.code } size='big'/>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={ handleClose }>
          { gettext('Закрыть') }
        </Button>
      </Modal.Footer>
    </Modal>
  </>
}

PictureModalPlayer.propTypes = {
  code: PropTypes.string.isRequired,
};

export default PictureModalPlayer;